import React, { useEffect, useState } from "react";
import { properties } from "../../../config/properties";
import {useLocation, useNavigate} from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Container,
    Icon,
    Row,
    Table,
    Pager,
    PagerItem,
    PagerLink, Dimmer, Label, Alert
} from "design-react-kit";

import Spinner from "../../layout/Spinner";
import RicercaSpecimen from "./ricercaSpecimen";

const styles = {
    // NUOVO: Contenitore per la tabella che gestisce lo scroll

    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '90vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },


};
const ElencoSpecimenRicercati = ({user}) => {
    const location = useLocation();
    const { ricerca } = location.state || {};

    const initialLimit = ricerca?.limit ?? 10;
    const initialOffset = ricerca?.offset ?? 0;

    const delayRefresh = 10;

    const [limit, setLimit] = useState(initialLimit);
    const [offset, setOffset] = useState(initialOffset);
    const [persone, setPersone] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [datiRicerca, setDatiRicerca] = useState(ricerca?.dati || {});

    const [sortField, setSortField] = useState("cognome");
    const [sortDirection, setSortDirection] = useState("desc"); // default: decrescente

    const [loadingUser, setLoadingUser] = useState(true);

    const navigate = useNavigate();

    const [alert, setAlert] = useState({visible: false, type: '', message: ''});

    const totalPages = Math.ceil(totalElements / limit);
    const currentPage = Math.floor(offset / limit) + 1;

    useEffect(() => {
        if (datiRicerca) {
            getPersoneList({
                userID: user.userID,
                cciaa: user.cciaa,
                gruppoUtente:user.gruppoUtente,
                offset,
                limit,
                dati: datiRicerca,
                sortField,
                sortDirection
            });
        }
    }, [offset, limit, datiRicerca, sortField, sortDirection]);

    const handleSearch = (id) => {
        const datiRicerca = {

            dati : {
                "id" : id
            }
        };

        navigate('/private/profiloSpecimen', { state: { ricerca: datiRicerca } });
    };

    const handleSort = (field) => {
        if (sortField === field) {
            // Se clicco la stessa colonna, inverto l'ordine
            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortField(field);
            setSortDirection("asc"); // reset a asc se è una nuova colonna
        }
    };



    const getPersoneList = async (params) => {
        try {
            setLoadingUser(true);

            const res = await fetch(
                properties.fullBaseUrl + properties.baseAppUrl + "/std/service/ricercaPersone",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(params),
                }
            );

            if(res.status === 401){

                const datasResponse = await res.json();

                setPersone([]);
                setTotalElements(0);

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }


            if (!res.ok) throw new Error("Errore HTTP");

            const data = await res.json();

            setTotalElements(data.totalElements || 0);
            setPersone(data.content || []);

        } catch (e) {

            setAlert({visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.'});
            setPersone([]);
            setTotalElements(0);
        }finally {
            setLoadingUser(false);
        }
    };

    const handleLimitChange = (newLimit) => {
        setLimit((prev) => {
            // React garantirà che il nuovo limit venga impostato prima del useEffect
            return newLimit;
        });
        setOffset(0); // questo causerà il useEffect a triggerarsi con offset 0 e nuovo limit
    };

    const handlePageChange = (page) => {
        const newOffset = (page - 1) * limit;
        setOffset(newOffset);
    };

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <Spinner active/>


            </Container>
        );


    }

    const renderPagination = () => {
        const pages = [];

        let startInd =  (currentPage-1) > 0 ? currentPage-1 : 1
        let endInd =  (currentPage+1) < totalPages ? currentPage+1 : totalPages


        if(currentPage > 2){
            pages.push(
                <PagerItem
                    key={1}
                    active={1 === currentPage}
                    className={1 === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={1 === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(1);
                        }}
                    >
                        {1}
                    </PagerLink>
                </PagerItem>
            );
            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );
        }

        for (let i =  startInd  ; i <= endInd  ; i++) {


            pages.push(
                <PagerItem
                    key={i}
                    active={i === currentPage}
                    className={i === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={i === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(i);
                        }}
                    >
                        {i}
                    </PagerLink>
                </PagerItem>
            );


        }

        if(currentPage < totalPages-2){

            pages.push(
                <PagerItem
                    key={"-"}

                >
                    <PagerLink
                    >
                        -
                    </PagerLink>
                </PagerItem>
            );

            pages.push(
                <PagerItem
                    key={totalPages}
                    active={totalPages === currentPage}
                    className={totalPages === currentPage ? "active-pager-item" : ""}
                >
                    <PagerLink
                        href="#"
                        aria-current={totalPages === currentPage ? "page" : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(totalPages);
                        }}
                    >
                        {totalPages}
                    </PagerLink>
                </PagerItem>
            );
        }
        return (
            <Pager className="mt-3 justify-content-center" aria-label="Navigazione elenco persone">
                <PagerItem disabled={currentPage === 1}>
                    <PagerLink
                        previous
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                        }}
                    >
                        <Icon icon="it-chevron-left" />
                    </PagerLink>
                </PagerItem>

                {pages}

                <PagerItem disabled={currentPage === totalPages}>
                    <PagerLink
                        next
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                        }}
                    >
                        <Icon icon="it-chevron-right" />
                    </PagerLink>
                </PagerItem>
            </Pager>
        );
    };

    return (
        <Container className="bg-white py-3 py-lg-6">
            {/* Card parametri di ricerca */}
            <div  className={"sticky-md-top"} style={{display: "flex", zIndex:1}} >
                <div style={{flex: 1}}>
                    <h2 className="mb-5">Elenco Persone</h2>
                </div>

                <div style={{flex: 1}} align={"right"}>

                </div>


            </div>

            {alert.visible && (
                <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({...alert, visible: false})}>
                    {alert.message}
                </Alert>
            )}

            <Row className="mb-4 justify-content-center">

                <Col md={4}>

                    <div className="mt-5 guidance-box lead sticky-md-top " style={{top: '100px'}}>

                        <p>
                            <Label tag="h5" className="text-primary mb-2">
                                Parametri di ricerca
                            </Label>


                            <Label className="mb-0"><strong>Nome:</strong> {datiRicerca?.nome || '-'}</Label>
                            <br/>
                            <Label className="mb-0"><strong>Cognome:</strong> {datiRicerca?.cognome || '-'}</Label>
                            <br/>
                            <Label className="mb-0">
                                <strong>Camera di Commercio:</strong>{" "}
                                {datiRicerca?.cciaa === "*" ? "Qualsiasi" : datiRicerca?.cciaa || "-"}
                            </Label>
                            <br/>
                            {/* Dropdown per selezionare il limite */}
                            <Row className="mb-3 ">
                                <Col xs="auto">
                                    <Label htmlFor="limit-select" className="mt-3"><strong>Righe per pagina:</strong>
                                    </Label>
                                </Col>
                                <Col xs="auto">
                                    <select
                                        id="limit-select"
                                        value={limit}
                                        onChange={(e) => handleLimitChange(Number(e.target.value))}
                                        className="form-select m-3"
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="auto">
                                    <Col sm="auto">
                                        <Button
                                            className={"btn btn-outline-primary"}
                                            type="click"
                                            onClick={() => {
                                                navigate('/private/ricercaSpecimen')
                                            }}
                                        >
                                            Nuova Ricerca
                                        </Button>
                                    </Col>
                                </Col>
                            </Row>
                        </p>
                    </div>
                </Col>

                <Col md={8}>

                    {persone.length > 0 && (
                        <>
                            <Row className="mt-2">
                                <Col className="text-end">
                                    <small className="text-muted">
                                        Visualizzati
                                        da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                                    </small>
                                </Col>
                            </Row>
                            {totalPages > 1 && renderPagination()}
                        </>
                    )}

                    <div style={styles.tableContainer}>

                        <Table hover className="border-top-0">
                            <thead>
                            <tr>
                                <th scope="col" className="text-center" style={{display: "none"}}>#</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}
                                    onClick={() => handleSort("cciaa")}>
                                    CCIAA{" "}
                                    {sortField === "cciaa" ?
                                        <Icon color={"white"}
                                              icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                        :
                                        <Icon color={"white"} icon={"it-minus"}/>
                                    }
                                </th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Nome</th>
                                <th scope="col" className="text-center" style={styles.tableHeader}
                                    onClick={() => handleSort("cognome")}>
                                    Cognome{" "}
                                    {sortField === "cognome" ?
                                        <Icon color={"white"}
                                              icon={sortDirection === "asc" ? "it-arrow-up-triangle" : "it-arrow-down-triangle"}/>
                                        :
                                        <Icon color={"white"} icon={"it-minus"}/>
                                    }
                                </th>
                                <th scope="col" className="text-center" style={styles.tableHeader}>Profilo</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white">
                            {persone.length > 0 ? (
                                persone.map((persona, index) => (
                                    <tr key={index}>
                                        <td scope="row" className="text-center"
                                            style={{display: "none"}}>{offset + index + 1}</td>
                                        <td className="text-center" style={styles.tableRowText}>{persona.cciaa}</td>
                                        <td className="text-center" style={styles.tableRowText}>{persona.nome}</td>
                                        <td className="text-center" style={styles.tableRowText}>{persona.cognome}</td>
                                        <td className={"action-icon text-center"} style={styles.actionButton}
                                            style={styles.tableRowText}><Icon icon="it-search"
                                                                              onClick={() => handleSearch(persona.id)}/>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" style={styles.tableRowText} colSpan="5">
                                        Nessun risultato trovato
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>

                    </div>



                    {persone.length > 0 && (
                        <>
                            <Row className="mt-2">
                                <Col className="text-end">
                                    <small className="text-muted">
                                        Visualizzati
                                        da <strong>{offset + 1}</strong> a <strong>{Math.min(offset + limit, totalElements)}</strong> di <strong>{totalElements}</strong> risultati
                                    </small>
                                </Col>
                            </Row>
                            {totalPages > 1 && renderPagination()}
                        </>
                    )}

                </Col>


            </Row>

            {/* Tabella risultati */}
            <Row className="justify-content-center">

            </Row>
        </Container>
    );
};

export default ElencoSpecimenRicercati;
